import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39cb8beb&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39cb8beb')) {
      api.createRecord('39cb8beb', component.options)
    } else {
      api.reload('39cb8beb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=39cb8beb&", function () {
      api.rerender('39cb8beb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/attractManage/attractCustomers/index.vue"
export default component.exports